import Avatar, { avatarClasses } from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';

const AVATAR_SIZE_DIALOG = 300;
const AVATAR_SIZE_SMALL = 110;

export const StyledAvatar = styled(Avatar, {
  shouldForwardProp: prop => prop !== 'sizes',
})(({ sizes, theme }) => ({
  backgroundColor: theme.palette.common.white,
  border: `2px solid ${theme.palette.grey[500]}`,
  ...(sizes === 'sx' && {
    [`&.${avatarClasses.root}`]: {
      height: AVATAR_SIZE_SMALL,
      width: AVATAR_SIZE_SMALL,
    },
  }),
  ...(sizes === 'lg' && {
    [`&.${avatarClasses.root}`]: {
      height: AVATAR_SIZE_DIALOG,
      width: AVATAR_SIZE_DIALOG,
    },
  }),
}));
